import { Injectable, EventEmitter } from "@angular/core";
import { DropdownItemComponent } from "./dropdown-item.component";

@Injectable()
export class Dropdown {
  itemClicked = new EventEmitter<DropdownItemComponent>();
  setAsDefault = new EventEmitter<DropdownItemComponent>();
  defaultUnchecked = new EventEmitter();
}
